<template>
  <b-card>
    <b-form lg="3" ref="userForm" @submit="onSubmit">
      <b-form-group id="usernameGroup">
        <span class="fieldHeader">{{$t('privatePage.username')}}:</span>
        <b-form-input id="usernameInput"
                      type="text"
                      v-model="currentUser.userName"
                      required
                      :plaintext="!currentUser.isNew">
        </b-form-input>
      </b-form-group>

      <b-form-group id="emailGroup">
        <span class="fieldHeader">{{$t('privatePage.email')}}:</span>
        <b-form-input id="emailInput"
                      type="email"
                      v-model="currentUser.email"
                      required>
        </b-form-input>
      </b-form-group>

      <b-form-group id="languageGroup">
        <span class="fieldHeader">{{$t('privatePage.language')}}:</span>
        <b-form-select id="languagePicker"
                       :options="languages"
                       value-field="languageId"
                       text-field="langName"
                       v-model="currentUser.languageId"
                       required>
        </b-form-select>
      </b-form-group>

      <b-form-group id="activeGroup"
                    v-if="!currentUser.isNew">
        <b-form-checkbox id="activeCheckbox"
                        v-model="currentUser.isActive"
                        v-if="!currentUser.isNew">
          {{ $t('privatePage.isActive') }}
        </b-form-checkbox>
      </b-form-group>

      <b-form-group id="savePasswordGroup"
                    v-if="!currentUser.isNew">
        <b-form-checkbox id="passwordCheckbox"
                        v-model="currentUser.savePassword"
                        v-if="!currentUser.isNew">
          {{ $t('privatePage.password_change') }}
        </b-form-checkbox>
      </b-form-group>

      <b-form-group id="passwordGroup"
                    v-show="currentUser.savePassword">
        <span class="fieldHeader">{{$t('privatePage.password')}}:</span>
        <b-form-input id="passwordInput"
                      type="password"
                      v-model="currentUser.password"
                      :required="currentUser.savePassword" >
        </b-form-input>
      </b-form-group>

      <b-form-group id="passwordGroup2"
                    v-show="currentUser.savePassword">
        <span class="fieldHeader">{{$t('privatePage.password_confirm')}}:</span>
        <b-form-input id="passwordInput2"
                      type="password"
                      v-model="currentUser.password2"
                      :required="currentUser.savePassword" >
        </b-form-input>
      </b-form-group>
      <b-button type="submit" class="me-1" ref="submitButton">{{ $t('save') }}</b-button>
      <b-button type="button" class="me-1" ref="cancelButton" v-on:click="onCancel">{{ $t('cancel') }}</b-button>
      <b-button type="button" variant="danger" @click.stop="deleteUser">{{ $t('delete') }}</b-button>
    </b-form>

    <b-alert v-model="alerts.warningCountdown"
             dismissible
             variant="warning"
             @closed="alerts.warningCountdown=0"
             @close-count-down="countDownChanged">
      {{alerts.warningMessage}}
    </b-alert>
  </b-card>
</template>

<script>
export default {
  name: 'user-editor',
  data() {
    return {
      alerts: {
        dismissSecs: 3,
        warningCountdown: 0,
        warningMessage: ''
      }
    }
  },
  props: {
    languages: {},
    currentUser: {
      userName: '',
      email: '',
      password: '',
      password2: '',
      languageId: '',
      isNew: false,
      savePassword: false
    }
  },
  computed: {
    user: function() {
      return {
        userName: this.currentUser.userName,
        email: this.currentUser.email,
        password: this.currentUser.password,
        savePassword: this.savePassword,
        languageId: this.currentUser.languageId
      }
    },
    deleteUserConfirmation() {
      return this.$t('privatePage.userDelete_confirmation')
    },
    passwordMismatchMessage() {
      return this.$t('privatePage.password_mismatch')
    },
    passwordWrongFormatMessage() {
      return this.$t('privatePage.password_wrongFormat')
    }
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.alerts.warningCountdown = dismissCountDown
    },
    showWarning: function(message) {
      this.alerts.warningMessage = message
      this.alerts.warningCountdown = this.alerts.dismissSecs
    },
    validateForm: function() {
      if (this.currentUser.savePassword) {
        if (this.currentUser.password !== this.currentUser.password2) {
          this.alerts.warningMessage = this.passwordMismatchMessage
          this.alerts.warningCountdown = this.alerts.dismissSecs
          return false
        }

        var re = /^(?!^[0-9]*$)(?!^[a-zA-Z]*$)^([a-zA-Z0-9]{6,14})$/
        if (!re.test(this.currentUser.password)) {
          this.alerts.warningMessage = this.passwordWrongFormatMessage
          this.alerts.warningCountdown = this.alerts.dismissSecs
          return false
        }
      }
      return true
    },
    deleteUser: function(group, user) {
      if (window.confirm(this.deleteUserConfirmation)) {
        this.$emit('userDeleteAttempt')
      }
    },
    onSubmit: function(evt) {
      evt.preventDefault()

      if (this.validateForm()) {
        this.$emit('formSubmitted')
      }
    },
    onCancel: function(evt) {
      this.$emit('formCancelled')
    }
  }
}
</script>
